export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_46-08c6904d9d05435c3df8591223088ce0.jpg";